import { useMutation } from "@tanstack/react-query";
import { type SubmitRedemptionPayload, submitRedemption } from "@/api/redemption";
import type { RedeemGiftResult } from "@/interfaces/redemption";

/**
 * Submit the recipient's chosen variant + shipping details (RFW-7).
 *
 * A plain mutation — the flow advances locally on success, and the redeem writes
 * `step = 'confirmed'` (not `redeemed`), so the still-mounted gift-context query
 * stays valid and needs no invalidation.
 */
export function useRedeemGift() {
  return useMutation<RedeemGiftResult, Error, SubmitRedemptionPayload>({
    mutationFn: submitRedemption,
  });
}
